import { FeConfigType } from "config/config";
import { getActiveBundleId, getBundles } from "containers/Bundles/Bundles.selectors";
import { getActiveOrDefaultProjectId } from "containers/Projects/Projects.selectors";
import { useSelector } from "react-redux";
import { checkBundleItemType, checkProjectItemType } from "utils/utils";

interface DefaultLocationProps {
    data?: any;
    resourceName: FeConfigType;
}

export const useDefaultLocation = ({ data, resourceName }: DefaultLocationProps) => {
    const activeProjectId = useSelector(getActiveOrDefaultProjectId);
    const activeBundleId = useSelector(getActiveBundleId);
    const bundleList = useSelector(getBundles);
    const isActiveBundleReadOnly = bundleList.find(
        (bundle) => bundle.id === activeBundleId
    )?.is_readonly;
    const isBundleItemType = checkBundleItemType(resourceName);
    const isProjectItemType = checkProjectItemType(resourceName);
    const defaultBundleId =
        data?.bundle_id ??
        (isActiveBundleReadOnly === false && isBundleItemType ? activeBundleId : null);

    if (defaultBundleId) {
        return { location: "bundle_id", locationId: defaultBundleId };
    } else {
        if (data?.project_id) {
            return { location: "project_id", locationId: data.project_id };
        } else if (isProjectItemType) {
            return {
                location: "project_id",
                locationId: activeProjectId,
            };
        }
    }
    return {};
};
